import React from 'react';
import { useAPI } from '../../contexts/Api';
import SetNewPassword from '../../components/SetNewPassword/SetNewPassword';

const Register = ({verify}) => {
    const api = useAPI();


    const verifyCallback = (email_token, name, password, onSuccess, onError) => {
        api.do_headuser_registration_verify(email_token, name, password, (resp) => {
            onSuccess(resp.msg);
        }, (error) => {
            onError(error.msg);
        });
    };

    const emailInputCallback = (email, onSuccess, onError) => {
        api.do_headuser_registration(email, (resp) => {
            onSuccess("Um deine Registrierung abzuschließen, folge dem Link, den wir an " + email + " gesendet haben.")
        }, (error) => {
            onError(error.msg);
        });
    };
     
    return (
        <>
            <SetNewPassword verify={verify} withName={true} verifyCallback={verifyCallback} emailInputCallback={emailInputCallback} verify_button_text="Account Erstellen" email_input_button_text="Weiter" />
        </>
    );
}

export default Register
